import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutSalespersonReassignmentProfileList extends Layout {
    layoutheaderProfiles: LayoutHeader;
    sourceSalespersonReassign: DataSource;
    tableProfiles: Table;
}
